/** @deprecated We don't restrict roles in the database anymore. */
export const internalRolePrefix = '#internal:';
/** @deprecated We don't restrict roles in the database anymore. */
export const isInternalRole = (roleName) => roleName.startsWith(internalRolePrefix);
